import { useFeatureValue } from '@growthbook/growthbook-react'
import { useEffect, useState } from 'react'
import { useEffectEvent } from 'use-effect-event'

import { AUTOMATIC_VOUCHER_CODE_OFF } from '@/src/domains/cart/constants'

export interface UseCartAutoVoucher {
  voucher?: string
  setVoucher: (voucher?: string) => void
}

export const useCartAutoVoucher = ({ voucher, setVoucher }: UseCartAutoVoucher) => {
  const automaticVoucherCode = useFeatureValue('automatic-voucher-code', AUTOMATIC_VOUCHER_CODE_OFF)

  const [isAutomaticVoucherApplied, setIsAutomaticVoucherApplied] = useState(false)

  const handleAutomaticVoucherCode = useEffectEvent(() => {
    if (automaticVoucherCode !== AUTOMATIC_VOUCHER_CODE_OFF && !isAutomaticVoucherApplied && !voucher) {
      setVoucher(automaticVoucherCode)
      setIsAutomaticVoucherApplied(true)

      console.log(`Automatic voucher code applied: ${automaticVoucherCode}`)
    }
  })

  useEffect(() => {
    handleAutomaticVoucherCode()
  }, [automaticVoucherCode])
}
